export default __webpack_public_path__ + "static/media/Icon awesome-search.8ef3fff9.svg";